module.exports = __webpack_public_path__ + "media/images/emblems/Buesserach-blason-c3f87995f2bcd44f9a1f855c51c4388c.png";